import React from 'react';

import * as S from './styles';

function Umbrella() {
  return <S.IoUmbrella />;
}

export default Umbrella;